module.exports = __webpack_public_path__ + "img/icon_error.d96f53d6.svg";